// extracted by mini-css-extract-plugin
export default {"Pepper":"#938D88","greyedOut":"Gdb749b","overlayTransition":"Ge85d7f G932350 Gb5bcda Gdadf80","modal":"G315b9f","willFade":"G7eaf62","fadeOut":"G234219 G7eaf62"};